export default __webpack_public_path__ + "static/media/twitter.acf9a8fb.svg";